import smoothscroll from 'smoothscroll-polyfill';
export class Tab {
    constructor() {
        this.param = null;

        //archive-curation
        this.curationTabStatus = 0;
        this.curationTabWrapper;
        this.curationTabContents;
        this.curationTabs;

        //index curation
        this.indexCurationTabStatus = 0;
        this.indexCurationTabWrapper;
        this.indexCurationTabContents;
        this.indexCurationTabs;

        // etc
        this.tabStatus = 0;
        this.tabWrapper;
        this.tabs;
        this.tabContentsFirst;
        this.tabContentsSecond;
    }

    init() {

        // indexページ > works, archive-worksページ
        // -----------------------------------------
        // #works-tab .js-tab-content-feature, .js-works-scroller-content
        if (document.getElementById('works-tab')) {
            this.tabStatus = 0;
            this.tabWrapper = document.getElementById('works-tab');
            this.tabContentsFirst = this.tabWrapper.querySelectorAll('.js-tab-content-feature');
            this.tabContentsSecond = this.tabWrapper.querySelectorAll('.js-works-scroller-content');
            

            //console.log(tabContentsFirst);
            //console.log(tabContentsSecond);

            this.tabs = this.tabWrapper.querySelectorAll('.js-tab');
            [].forEach.call(this.tabs,  (elem, index) => {
                elem.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.tabStatus = index;
                    this.tabClicked2(elem);
                });
            });
        }




        // archive-curationページ
        if (document.getElementById('curation-tab')) {
            this.curationTabWrapper = document.getElementById('curation-tab');
            this.curationTabContents = this.curationTabWrapper.querySelectorAll('.js-article');
            this.curationTabs = this.curationTabWrapper.querySelectorAll('.js-tab');

            [].forEach.call(this.curationTabs, (elem,index) => {
                elem.addEventListener('click', (e) => {
                    e.preventDefault();
                    //this.curationTabContents
                    this.curationTabStatus = index;
                    this.tabClicked3(elem);
                });
            });
            
            this.tabClicked3(this.curationTabs[0]);
        }


        // indexページ > curation
        // -----------------------------------------
        // #index-curation .category-selector .category-selector__link
        if (document.getElementById('index-curation-tab')) {
            this.indexCurationTabWrapper = document.getElementById('index-curation-tab');
            this.indexCurationTabContents = this.indexCurationTabWrapper.querySelectorAll('.js-curation-swiper');
            this.indexCurationTabs = this.indexCurationTabWrapper.querySelectorAll('.js-tab');

            [].forEach.call(this.indexCurationTabs, (elem,index) => {
                elem.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.indexCurationTabStatus = index;
                    this.tabClicked4(elem);
                });
            });
            
            this.tabClicked4(this.indexCurationTabs[0]);

        }

    }

    //this.tabStatus番目のタブを表示
    tabClicked2 = function (cleckedElem) {
        //console.log(cleckedElem);
        // console.log(`TAB: this.tabStatus=${this.tabStatus}`);

        // tabの切り替え
        //let tabs = this.tabWrapper.querySelectorAll('.js-tab');
        [].forEach.call(this.tabs, function (elem) {
            elem.classList.remove('selected');
        });
        cleckedElem.classList.add('selected');
        

        // コンテンツの切り替え/大画像(横スライド)
        if(this.tabContentsFirst.length>0){
            [].forEach.call(tabContentsFirst, function (elem) {
                elem.classList.remove('is-show');
            });
            this.tabContentsFirst[this.tabStatus].classList.add('is-show');
        }

        // コンテンツの切り替え/小画像
        [].forEach.call(this.tabContentsSecond, function (elem) {
            elem.classList.remove('is-show');
        });
        this.tabContentsSecond[this.tabStatus].classList.add('is-show');
    }


    tabClicked4(cleckedElem) {
        //console.log(cleckedElem.dataset.term);

        let selectedCategory = '';

        // tabの切り替え
        [].forEach.call(this.indexCurationTabs, function (elem) {
            elem.classList.remove('selected');
        });
        cleckedElem.classList.add('selected');

        // コンテンツの切り替え
        let showCategoryNum = 0;
        if(cleckedElem.dataset.term == 'curation'){
            showCategoryNum = 1;
            selectedCategory = 'curation';
        }else if(cleckedElem.dataset.term == 'cross-talk'){
            showCategoryNum = 2;
            selectedCategory = 'cross-talk';
        } else {
            showCategoryNum = 0;
            selectedCategory = 'all';
        }
        [].forEach.call(this.indexCurationTabContents, function (elem, index) {
            if(index == showCategoryNum){
                elem.classList.add('is-show');
            }else{
                elem.classList.remove('is-show');
            }
        });

        // coming soonのためのカウント
        let showCount = 0;
        let slides = document.getElementById('index-curation-tab').querySelectorAll('.js-curation-swiper')[showCategoryNum].querySelectorAll('.swiper-slide');
        [].forEach.call(slides, function (elem) {
            if(elem.classList.contains(selectedCategory)){
                showCount ++;
            }
        });
        //console.log(showCount);

        const signNoContent = cleckedElem.parentElement.parentElement.parentElement.parentElement.querySelector('.js-noconent-category');
        if(showCount == 0 && selectedCategory != 'all'){
            signNoContent.classList.add('is-show');
        }else{
            signNoContent.classList.remove('is-show');
        }

        // [].forEach.call(this.indexCurationTabContentsPc, function (elem) {
        //     let windowWidth = document.documentElement.clientWidth;
        //     elem.classList.remove('is-show');
            
        //     // 表示数制限について
        //     let isPC = true;
        //     let maxShow = 99;
        //     if(windowWidth > 1920){
        //         maxShow = 4;
        //     }else if(windowWidth > 700){
        //         maxShow = 3;
        //     }else{
        //         maxShow = 99;
        //         isPC = false;
        //     }

        // });


        // コンテンツの切り替え(カテゴリ)
        // [].forEach.call(this.indexCurationTabContents, function (elem) {
        //     let windowWidth = document.documentElement.clientWidth;
        //     elem.classList.remove('is-show');
            
        //     // 表示数制限について
        //     let isPC = true;
        //     let maxShow = 99;
        //     if(windowWidth > 1920){
        //         maxShow = 4;
        //     }else if(windowWidth > 700){
        //         maxShow = 3;
        //     }else{
        //         maxShow = 99;
        //         isPC = false;
        //     }
            
        //     if(isPC){
        //         //PCでBlock表示
        //         if(cleckedElem.dataset.term == 'all'){
        //             showCount ++;
        //             if(showCount<=maxShow){
        //                 elem.classList.add('is-show');
        //             }
        //         }else{
        //             if(elem.classList.contains(cleckedElem.dataset.term)){
        //                 showCount ++;
        //                 if(showCount<=maxShow){
        //                     elem.classList.add('is-show');
        //                 }
        //             }
        //         }
        //     }else{
        //         //SPでSwiper表示
        //         // if(cleckedElem.dataset.term == 'all'){
        //         //     elem.classList.add('is-show');
        //         // }else{
        //         //     if(elem.classList.contains(cleckedElem.dataset.term)){
        //         //         elem.classList.add('is-show');
        //         //     }
        //         // }
        //     }

        // });
    }

    tabClicked3(cleckedElem) {
        // tabの切り替え
        [].forEach.call(this.curationTabs, function (elem) {
            elem.classList.remove('selected');
        });
        cleckedElem.classList.add('selected');

        // コンテンツの切り替え
        let showCount = 0;
        [].forEach.call(this.curationTabContents, function (elem) {

            //elem.classList.remove('is-show');
            // 表示数制限なしver
            if(cleckedElem.dataset.term == 'all'){
                elem.classList.add('is-show');
                showCount ++;
            }else{
                elem.classList.remove('is-show');
                if(elem.classList.contains(cleckedElem.dataset.term)){
                    elem.classList.add('is-show');
                    showCount ++;
                }
            }
        });

        // coming soon
        //console.log(cleckedElem.parentElement.parentElement.parentElement.parentElement);
        const signNoContent = cleckedElem.parentElement.parentElement.parentElement.parentElement.querySelector('.js-noconent-category');
        if(showCount === 0){
            signNoContent.classList.add('is-show');
        }else{
            signNoContent.classList.remove('is-show');
        }
    }

    onResize(){
        // if (document.getElementById('curation-tab')) {
        //     this.tabClicked3(this.curationTabs[this.curationTabStatus]);
        // }
         if (document.getElementById('index-curation-tab')) {
            this.tabClicked4(this.indexCurationTabs[this.indexCurationTabStatus]);
        }
    }
    
    onLoadTabChange(num){
        if (document.getElementById('works-tab') && this.tabWrapper.querySelectorAll('.js-tab')[num]) {
            this.tabStatus = num;
            this.tabClicked2(this.tabWrapper.querySelectorAll('.js-tab')[num]);
        }
    }

}